/* Copyright 2014 The MathWorks, Inc. */

/* Generic mixin for Error state and Warning State
 This mixin will help in setting the error state and warning state for different widgets
 */

define([
    "dojo/_base/declare",
    "dojo/dom-class",
    "dojo/mouse",
    "dojo/dom-geometry",
    "dojo/dom-construct",
    "dojo/on",
    "dojo/_base/window",
    "./Tooltip"
], function (declare, domClass, mouse, domGeom, domConstruct, on, win, Tooltip) {

    var TOOLTIP_LEFT = "left", TOOLTIP_RIGHT = "right";
    return declare(null, {

        // If there is no tooltip created, create a tooltip and place it in body
        _createValidationtooltip: function () {
            if (!this.validationTooltip) {
                this.validationTooltip = new Tooltip({

                });
                this.own(this.validationTooltip);
                domConstruct.place(this.validationTooltip.domNode, win.body());
                this._addTooltipEvents();
            }
        },

        _setErrorTextAttr: function (value) {
            if (this.validationTooltip) {
                this.validationTooltip.textNode.textContent = value;
            }
            this._set("errorText", value);
        },

        _setWarningTextAttr: function (value) {
            if (this.validationTooltip) {
                this.validationTooltip.textNode.textContent = value;
            }
            this._set("warningText", value);
        },

        _setValidationStateAttr: function (value) {
            var inWarning = false, inError = false;
            if (value.toLowerCase() === "error") {
                inError = true;
                this._createValidationtooltip();
                this.validationTooltip.textNode.textContent = this.errorText;
            } else if (value.toLowerCase() === "warning") {
                inWarning = true;
                this._createValidationtooltip();
                this.validationTooltip.textNode.textContent = this.warningText;
            }
            if (this.validationTooltip) {
                domClass.toggle(this._getDomNodeForValidationClasses(), "has-error", inError);
                domClass.toggle(this.validationTooltip.domNode, "error-tooltip", inError);
                domClass.toggle(this.validationTooltip.domNode, "warning-tooltip", inWarning);
                //Show only on hover or focus: hide it
                this.validationTooltip.domNode.style.visibility = "hidden";
            }
            this._set("validationState", value);
        },

        _flipDomOrder: function (tooltip) {

            var firstChild = tooltip.children[0], lastChild = tooltip.children[1];
            // Place first child after last child so that the two nodes are swapped
            domConstruct.place(firstChild, domConstruct.place(lastChild, tooltip), "after");
            domConstruct.place(lastChild.children[0], domConstruct.place(lastChild.children[1], lastChild), "after");
        },
        //gettooltiporientation
        _tooltipOrientation: function () {
            if (domClass.contains(this.validationTooltip.domNode, "dijitTooltipLeft")) {
                return TOOLTIP_LEFT;
            } else {
                return TOOLTIP_RIGHT;
            }
        },

        //Widgets will override this function to describe which Node to apply the has-warning and has-error classes
        //RadioButton, check box = > widget.labelNode
        //Combo Box => widget.combobox
        // Slider => widget.sliderTrackNode
        _getDomNodeForValidationClasses: function () {
            return this.domNode;
        },

        //For focus different widgets will override this function to give focus to domNode
        _getFocusWidget: function () {
            return this;
        },
        _placeTooltip: function () {
            if (this.validationTooltip) {
                if ((this.validationState === "error") || (this.validationState === "warning")) {
                    var domNodePosition = domGeom.position(this.domNode), widgetPositionX, widgetPositionY, widgetWidth, tooltipWidth, widgetHeight, tooltipDomNode, tooltipHeight, browserWidth, positionLeft, positionTop, isLeft = false;
                    widgetPositionX = domNodePosition.x;
                    widgetPositionY = domNodePosition.y;
                    widgetWidth = domNodePosition.w;
                    //Place the tooltip inside body initially to calculate widgetWidth and then place it at the exact left and top values

                    // If widget is in error state Place the error text in the template of tooltip
                    if (this.validationState === "error") {
                        //For red border
                        domClass.add(this._getDomNodeForValidationClasses(), "has-error");
                        // add the text to be displayed
                        this.validationTooltip.textNode.textContent = this.errorText;
                        //For tooltip styling
                        domClass.add(this.validationTooltip.domNode, "error-tooltip");
                        // If widget is in warning state Place the warning text in the template of tooltip
                    } else if (this.validationState === "warning") {
                        //add the text to be displayed
                        this.validationTooltip.textNode.textContent = this.warningText;
                        //For tooltip styling
                        domClass.add(this.validationTooltip.domNode, "warning-tooltip");

                    }
                    // Set the position as absolute and make tooltip visible
                    this.validationTooltip.domNode.style.visibility = "visible";
                    tooltipHeight = domGeom.position(this.validationTooltip.domNode).h / 2;
                    widgetHeight = domGeom.position(this.domNode).h / 2;
                    tooltipDomNode = this.validationTooltip.domNode;
                    browserWidth = domGeom.position(win.body()).w;
                    tooltipWidth = this._calculateTooltipWidth();
                    // Check if Tooltip can fit on right
                    // check if position of widget + widgetWidth of the errortext/warningtext + image + arrow can fit it on right (Tooltip width)
                    if (widgetPositionX + widgetWidth + tooltipWidth > browserWidth) {
                        //Place tooltip on left : delete the size of the tooltip to mark its position
                        isLeft = true;

                        positionLeft = widgetPositionX - tooltipWidth + "px";
                        positionTop = widgetPositionY + widgetHeight - tooltipHeight + document.body.scrollTop + "px";

                        // If the tooltip appears on the left, the dom order is incorrect
                        // Flip the dom order when ever the tooltip is on the left of widget
                        if (domClass.contains(tooltipDomNode.children[0], "tooltipConnector")) {
                            this._flipDomOrder(tooltipDomNode);
                        }
                        // Place tooltip on right
                    } else {

                        positionLeft = widgetPositionX + widgetWidth + "px";
                        positionTop = widgetPositionY + widgetHeight - tooltipHeight + document.body.scrollTop + "px";
                        // If the tooltip appears on the right, make sure the dom order is correct
                    }
                    //Set the position of tooltip
                    domClass.toggle(this.validationTooltip.domNode, "tooltipLeft", isLeft);
                    domClass.toggle(this.validationTooltip.domNode, "tooltipRight", !isLeft);
                    this.validationTooltip.domNode.style.left =  positionLeft;
                    this.validationTooltip.domNode.style.top = positionTop;

                }
            }
        },
        _calculateTooltipWidth: function () {
            //Add connector and remove connector to find its width
            domClass.add(this.validationTooltip.domNode, "tooltipLeft");
            var width = domGeom.position(this.validationTooltip.domNode).w;
            domClass.remove(this.validationTooltip.domNode, "tooltipLeft");
            return width;
        },
        _addTooltipEvents: function () {
            var that = this;   //Get the widget which has focus => for composition widgets, get the actual widget
            this.own(
                // For composition widgets, this refers to entire widget and hovering implies hovering over the entire widget
                // When you mouseover a widget, only if the widget is in error state or warning state show tooltip
                on(this, mouse.enter, function () {
                    that._placeTooltip();             //Tooltip pass widget as argument
                }),

                // On mouse leave set visibility of tooltp to hidden
                on(this, mouse.leave, function () {
                    if (that.validationTooltip) {
                        that.validationTooltip.domNode.style.visibility = "hidden";
                    }
                }),
                // On focus, if widget is in error or in warning state, make tooltip visible
                on(this._getFocusWidget(), "focus", function () {
                    that._placeTooltip();
                    if (that.validationTooltip) {
                        if (that.get("validationState") === "error" || that.get("validationState") === "warning") {
                            domClass.add(that.validationTooltip.domNode, "validationFocused");
                        }
                    }
                }),
                // On blur, hide the tooltip
                on(this._getFocusWidget(), "blur", function () {
                    if (that.validationTooltip) {
                        domClass.remove(that.validationTooltip.domNode, "validationFocused");
                        that.validationTooltip.domNode.style.visibility = "hidden";
                    }
                }));
        }
    });
});
